import React from 'react';
import { Route } from 'react-router-dom';
import DynamicDashboardRoutes from './DynamicDashboard/routes';
const routes = () => [<DynamicDashboardRoutes key="DynamicDashboardRoutes" />];

const DynamicDashboardRoute = () => <Route component={routes} />;

export default DynamicDashboardRoute;



// WEBPACK FOOTER //
// src/modules/screens/dynamicDashboard/routes.js